'use client';

import React, { useState, useEffect, useMemo } from "react";
import Image from "@src/components/atoms/safe-image";
import _ from "lodash";
import { useSearchParams } from 'next/navigation';

// Ctx
import useListListingCtx from "@src/context/list-listing-office-ctx";

// Assets
import ISort from "@public/png/icon-order.png"

// Components
import ModalFilterListListing from "@src/components/atoms/modal-filter-list-listing"

const ListListingFilter = () => {
  const { listPropertyCategories, handleApply, params: globalParams } = useListListingCtx()
  const searchParams = useSearchParams();

  const [openModal, setOpenModal] = useState(false)

  const [params, setParams] = useState({
    "property_category_id": searchParams.get("property_category_id") ?? null,
    "price[min]": searchParams.get("price[min]") ?? null,
    "price[max]": searchParams.get("price[max]") ?? null,
    "surface_area[min]": searchParams.get("surface_area[min]") ?? null,
    "surface_area[max]": searchParams.get("surface_area[max]") ?? null,
    "building_area[min]": searchParams.get("building_area[min]") ?? null,
    "building_area[max]": searchParams.get("building_area[max]") ?? null,
    "bedroom": searchParams.get("bedroom") ?? null,
    "additional_bedroom": searchParams.get("additional_bedroom") ?? null,
    "bathroom": searchParams.get("bathroom") ?? null,
    "additional_bathroom": searchParams.get("additional_bathroom") ?? null,
    "_order": searchParams.get("_order") ?? null,
  });

  const [openItem, setOpenItem] = useState(null);

  const selectedCategory = useMemo(() => {
    if (!listPropertyCategories?.length) return "";

    return listPropertyCategories.find(d => d.id === +params.property_category_id)?.name ?? "";
  }, [params, listPropertyCategories]);

  const selectedSort = useMemo(() => {
    if (!params["_order"]) return "";

    if (params["_order"] === "highest-price") {
      return "Harga Tinggi ke Rendah"
    }

    if (params["_order"] === "lowest-price") {
      return "Harga Rendah ke Tinggi"
    }

    return ""
  }, [params]);

  const DisplayPrice = useMemo(() => {
    if (!params["price[min]"] && !params["price[max]"]) return null;

    let result = []

    if (!!params["price[min]"]) {
      result[0] = `Rp.${Number(params["price[min]"]).toLocaleString("id-ID")}`
    }

    if (!params["price[min]"] && !!params["price[max]"]) {
      result[0] = "Rp.0"
    }

    if (!!params["price[max]"]) {
      result[1] = `Rp.${Number(params["price[max]"]).toLocaleString("id-ID")}`
    }

    if (!params["price[max]"] && !!params["price[min]"]) {
      result[1] = "Tidak terbatas"
    }

    return <p className="text-start text-[14px] font-satoshi-bold mt-1">{result.join(" - ")}</p>
  }, [params])

  const DisplayLT = useMemo(() => {
    if (!params["surface_area[min]"] && !params["surface_area[max]"]) return null;

    let result = [];

    if (params["surface_area[min]"]) {
      result.push(
        <span key="min">
          {Number(params["surface_area[min]"]).toLocaleString("id-ID")}
          m<sup>2</sup>
        </span>
      );
    } else if (params["surface_area[max]"]) {
      result.push(<span key="min">0</span>);
    }

    if (params["surface_area[max]"]) {
      result.push(
        <span key="max">
          {Number(params["surface_area[max]"]).toLocaleString("id-ID")}
          m<sup>2</sup>
        </span>
      );
    } else if (params["surface_area[min]"]) {
      result.push(<span key="max">Tidak terbatas</span>);
    }

    return (
      <p className="text-start text-[14px] font-satoshi-bold mt-1">
        {result.map((item, index) => (
          <React.Fragment key={index}>
            {index > 0 && " - "}
            {item}
          </React.Fragment>
        ))}
      </p>
    );
  }, [params]);

  const DisplayLB = useMemo(() => {
    if (!params["building_area[min]"] && !params["building_area[max]"]) return null;

    let result = [];

    if (params["building_area[min]"]) {
      result.push(
        <span key="min">
          {Number(params["building_area[min]"]).toLocaleString("id-ID")}
          m<sup>2</sup>
        </span>
      );
    } else if (params["building_area[max]"]) {
      result.push(<span key="min">0</span>);
    }

    if (params["building_area[max]"]) {
      result.push(
        <span key="max">
          {Number(params["building_area[max]"]).toLocaleString("id-ID")}
          m<sup>2</sup>
        </span>
      );
    } else if (params["building_area[min]"]) {
      result.push(<span key="max">Tidak terbatas</span>);
    }

    return (
      <p className="text-start text-[14px] font-satoshi-bold mt-1">
        {result.map((item, index) => (
          <React.Fragment key={index}>
            {index > 0 && " - "}
            {item}
          </React.Fragment>
        ))}
      </p>
    );
  }, [params]);

  const DisplayRuangan = useMemo(() => {
    if (!params["bedroom"] && !params["bathroom"]) return null;

    let result = [];

    if (params["bedroom"]) {
      result.push(
        <span key="min">Kamar Tidur: {params["bedroom"]} {!!params["additional_bedroom"] && `+${params["additional_bedroom"]}`}</span>
      );
    }

    if (params["bathroom"]) {
      result.push(
        <span key="min">Kamar Mandi: {params["bedroom"]} {!!params["additional_bathroom"] && `+${params["additional_bathroom"]}`}</span>
      );
    }

    return (
      <p className="text-start text-[14px] font-satoshi-bold mt-1">
        {result.map((item, index) => (
          <React.Fragment key={index}>
            {index > 0 && ", "}
            {item}
          </React.Fragment>
        ))}
      </p>
    );
  }, [params]);


  const disabledHapusFilter = useMemo(() => !_.some(params, Boolean), [params])
  const counter = useMemo(() => {
    let count = 0;

    if (globalParams["price[min]"] || globalParams["price[max]"]) count++;
    if (globalParams["surface_area[min]"] || globalParams["surface_area[max]"]) count++;
    if (globalParams["building_area[min]"] || globalParams["building_area[max]"]) count++;
    if (globalParams["_order"]) count++;
    if (globalParams["bedroom"] || globalParams["bathroom"]) count++;
    if (!!globalParams["property_category_id"]) count++;

    return count;
  }, [globalParams]);


  const handleResetForm = () => {
    setParams({
      "property_category_id": null,
      "price[min]": null,
      "price[max]": null,
      "surface_area[min]": null,
      "surface_area[max]": null,
      "bedroom": null,
      "additional_bedroom": null,
      "bathroom": null,
      "additional_bathroom": null,
      "building_area[min]": null,
      "building_area[max]": null,
      "_order": null,
    })
  }

  useEffect(() => {
    if (+params["bedroom"] <= 0) {
      const newParams = { ...params }
      newParams["additional_bedroom"] = null
      setParams(newParams)
    }
  }, [params["bedroom"]])

  useEffect(() => {
    if (+params["bathroom"] <= 0) {
      const newParams = { ...params }
      newParams["additional_bathroom"] = null
      setParams(newParams)
    }
  }, [params["bathroom"]])

  useEffect(() => {
    if (!globalParams["property_category_id"]) {
      setParams({ ...params, property_category_id: null })
    }
  }, [globalParams["property_category_id"]])

  useEffect(() => {
    if (openModal) {
      setParams({ ...globalParams })
    }
  }, [openModal])

  const handleOpenModal = () => {
    setOpenModal(true)
  }
  const handleCloseModal = () => {
    setOpenModal(false)
  }

  const applyFilter = () => {
    handleApply("filter", params, handleCloseModal)
  }

  return (
    <>
      <button onClick={handleOpenModal} className="w-fit cursor-pointer rounded bg-white flex items-center justify-center border border-solid border-[#E6E7E8] p-[12px] h-[40px] gap-[12px]">
        {!!counter && <span className="flex items-center justify-center h-4 w-4 px-2.5 py-2.5 rounded bg-[#252526] border-[2px] border-solid border-white text-white text-[14px] font-satoshi">{counter}</span>}
        <span className="text-[14px] font-satoshi-bold dd2-lg:hidden">Urutkan & Filter</span>
        <Image
          width={24}
          height={24}
          src={ISort}
          alt='Icon Sort'
          className='object-contain'
        />
      </button>

      <ModalFilterListListing
        isOpen={openModal}
        onClose={handleCloseModal}
        listCategory={listPropertyCategories}
        applyFilter={applyFilter}
        openItem={openItem}
        setOpenItem={setOpenItem}
        selectedCategory={selectedCategory}
        DisplayPrice={DisplayPrice}
        selectedSort={selectedSort}
        DisplayLT={DisplayLT}
        DisplayLB={DisplayLB}
        DisplayRuangan={DisplayRuangan}
        handleResetForm={handleResetForm}
        params={params}
        setParams={setParams}
        disabledHapusFilter={disabledHapusFilter}
      />
    </>
  )
}

export default ListListingFilter
